import { create } from 'zustand';

export const usePdInventoryStore = create((set) => ({
    // Data State
    items: [],
    loading: false,
    error: null,
    success: null,

    // UI State
    isFormOpen: false,
    selectedItem: null,
    isDetailsOpen: false,
    isDeleteDialogOpen: false,

    // Pagination & Filtering
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 1,
        hasNextPage: false,
        hasPreviousPage: false,
    },
    sorting: {
        sortBy: 'createdAt',
        sortDirection: 'desc'
    },
    search: '',
    columnFilters: {},
    uniqueValues: {},

    // Actions
    setData: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setSuccess: (success) => set({ success }),

    setPagination: (pagination) => set((state) => ({
        pagination: { ...state.pagination, ...pagination }
    })),

    setSorting: (sorting) => set((state) => ({
        sorting: { ...state.sorting, ...sorting }
    })),

    setSearch: (search) => set({ search }),

    setColumnFilters: (filters) => set({ columnFilters: filters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),

    // Form Helpers
    openForm: (item = null) => set({ isFormOpen: true, selectedItem: item }),
    closeForm: () => set({ isFormOpen: false, selectedItem: null }),

    openDeleteDialog: (item) => set({ isDeleteDialogOpen: true, selectedItem: item }),
    closeDeleteDialog: () => set({ isDeleteDialogOpen: false, selectedItem: null }),

    // Details Helpers
    openDetailsDialog: (item) => set({ isDetailsOpen: true, selectedItem: item }),
    closeDetailsDialog: () => set({ isDetailsOpen: false, selectedItem: null }),

    // Clearers
    clearError: () => set({ error: null }),
    clearSuccess: () => set({ success: null }),
    reset: () => set({
        items: [],
        loading: false,
        error: null,
        success: null,
        isFormOpen: false,
        isDetailsOpen: false,
        selectedItem: null,
        search: '',
        columnFilters: {},
        isDeleteDialogOpen: false
    })
}));
